module.exports = __webpack_public_path__ + "static/media/AR_SDK@2x.43ab82bd.png";